import BaseDivider from "./BaseDivider"
export const Divider={
    "Divider":BaseDivider
}